<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card card-top-line">
          <div class="header">
            <h2>Manage Remitter Group</h2>
          </div>
          <div class="body pt-0">
            <div class="chart-top-action d-lg-flex justify-content-end py-3">
              <div
                class="d-md-flex justify-content-between mt-lg-0 mt-md-3 mt-0"
              >
                <div
                  class="payment-dropdown d-flex flex-row-reverse ml-lg-3 mt-3 mt-sm-0"
                >
                  <router-link
                    class="btn btn-primary btn-mw btn-lg"
                    to="/list/remitter-group-management/add"
                  >
                    Add New
                    <i class="fa fa-plus-square"></i>
                  </router-link>
                </div>
              </div>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <b-table
              ref="partnertable"
              responsive
              hover
              table-class="js-basic-example table-custom mb-0 border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(srno)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(action)>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item>Edit</b-dropdown-item>
                  <b-dropdown-item @click="showAlert">Delete</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
              v-if="totalRows > 10"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
import "@/plugins/sweetalert2";
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
// import { GET_PARTNER_LIST } from "../../../store/actions.type.js";
import { mapState, mapGetters } from "vuex";
export default {
  name: "RemitterGroupManagement",
  components: {
    BreadCrumb,
    "main-loader": LoaderComponent,
  },
  data() {
    return {
      items: [
        {
          name: "Red",
          action: "",
        },
        {
          name: "Basic",
          action: "",
        },
        {
          name: "Bronze",
          action: "",
        },
        {
          name: "Silver",
          action: "",
        },
        {
          name: "Silver-PLUS",
          action: "",
        },
        {
          name: "Gold",
          action: "",
        },
        {
          name: "Platinum",
          action: "",
        },
        {
          name: "TEST",
          action: "",
        },
        {
          name: "Dormant",
          action: "",
        },
        {
          name: "Not Transacted",
          action: "",
        },
        {
          name: "GREY - Unvalidated Profiles",
          action: "",
        },
        {
          name: "Expired",
          action: "",
        },
        {
          name: "Hibernate",
          action: "",
        },
        {
          name: "Bank Transferred Profiles",
          action: "",
        },
        {
          name: "Grey",
          action: "",
        },
      ],

      fields: [
        {
          key: "srno",
          label: "SR No",
          sortable: true,
          thClass: "th_sortfix",
          thStyle: { width: "10%" },
        },
        {
          key: "name",
          label: "Remitter Group Name",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "action",
          label: "Action",
          sortable: true,
          thClass: "th_sortfix",
          thStyle: { width: "25%" },
        },
      ],

      totalRows: 0,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 100, text: 100 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filterValue: "",
      condition: "",
    };
  },
  methods: {
    getSentNotificationList() {
      // this.$store.dispatch(GET_PARTNER_LIST).then((response) => {
      //     console.log(response)
      // });
    },
    showAlert() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to delete this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success",
            );
          }
        });
    },
  },
  mounted() {
    this.totalRows = this.items.length;
    this.getSentNotificationList();
  },
  computed: {
    ...mapGetters(["isLoading"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
